const configuredShowcaseUrl = import.meta.env.VITE_SHOWCASE_URL?.trim();

export const SHOWCASE_BASE = (
  configuredShowcaseUrl ||
  (import.meta.env.DEV ? "/showcase" : "https://demo.ontoligent.io/showcase")
).replace(/\/+$/, "");

export const prototypeUrl = (slug: string) =>
  `${SHOWCASE_BASE}/app/solutions/${slug}/index.html`;